import React from 'react';
import styled from 'styled-components';
import assistantClient from '@requests/telnyx/assistants.requests';
import DotLoader from '@svg/dot_loader';

import { Chip, Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { AIAssistant } from '@requests/telnyx';
import { RequestError } from '@requests/common';
import { AutoAwesomeOutlined } from '@mui/icons-material';
import { NodeBodyContainer } from '@common/Node';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.35rem;
  margin: 0;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  color: ${({ theme }) => theme.text.subtext};
  border-bottom: 1px solid ${({ theme }) => theme.line.node};

  & .MuiChip-root {
    padding: 8px;
    padding-right: 4px;
  }

  & .MuiChip-icon {
    margin-left: 0 !important;
    font-size: 14px !important;
    margin-right: 0rem !important;
  }
`;

export const formatAssistantName = (name: string) => {
  let formatted = name.replace(/ /g, '_');
  formatted = formatted.replace(/[^a-zA-Z0-9_\-]/g, '');
  return formatted.toLowerCase();
};

interface Props {
  assistantIds: string[];
  system?: string;
}

export const AssistantNodeChips: React.FC<Props> = ({ assistantIds, system }) => {
  const { data: assistants = [], isLoading } = useQuery<AIAssistant[], RequestError>({
    queryKey: ['ai_assistants'],
    queryFn: assistantClient.list,
    retry: false,
  });

  if (assistantIds.length === 0 && !isLoading) return null;

  return (
    <Stack>
      {assistantIds.filter(Boolean).length > 0 && (
        <Container>
          {assistantIds.map((assistantId) => {
            const assistant = assistants.find((assistant) => assistant.id === assistantId);
            if (assistant)
              return (
                <Chip
                  key={assistantId}
                  icon={<AutoAwesomeOutlined />}
                  label={formatAssistantName(assistant.name)}
                  sx={{ fontSize: '9px' }}
                  size='small'
                  variant='outlined'
                />
              );

            if (isLoading) {
              return (
                <Chip
                  key={assistantId}
                  label={
                    <Stack display='flex' alignItems='center' justifyContent='center'>
                      <DotLoader height={6} color='#000000' />
                    </Stack>
                  }
                  sx={{ fontSize: '9px', padding: '8px !important' }}
                  size='small'
                  variant='outlined'
                />
              );
            }
            return null;
          })}
        </Container>
      )}

      {system && (
        <NodeBodyContainer>
          {system.length > 490 ? `${system.slice(0, 490).replace(/- /g, '')}...` : system.replace(/- /g, '')}
        </NodeBodyContainer>
      )}
    </Stack>
  );
};
